import { render, staticRenderFns } from "./TreeSelect.vue?vue&type=template&id=89279b04&scoped=true"
import script from "./TreeSelect.vue?vue&type=script&lang=js"
export * from "./TreeSelect.vue?vue&type=script&lang=js"
import style0 from "./TreeSelect.vue?vue&type=style&index=0&id=89279b04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89279b04",
  null
  
)

export default component.exports